export class AppSettings {
    public webSocketTunnelUrl = import.meta.env.VITE_WEB_SOCKET_TUNNEL_URL;

    private static instance: AppSettings | null = null;

    public static getInstance(): AppSettings {
        if (!this.instance) {
            this.instance = new AppSettings();
        }

        return this.instance;
    }
}